import api from '../../../api/consultations/_dhis2-diagnostics.js'

export default {
    saveDHIS2Diagnostic(data) {
        return new Promise((resolve, reject) => {
            api.saveDHIS2Diagnostic(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDHIS2Diagnostic(data) {
        return new Promise((resolve, reject) => {
            api.getDHIS2Diagnostic(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteConsultationDHIS2Diagnostic(data) {
        return new Promise((resolve, reject) => {
            api.deleteConsultationDHIS2Diagnostic(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getStatConsultationDHIS2(data) {
        return new Promise((resolve, reject) => {
            api.getStatConsultationDHIS2(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    sendStatConsultationDHIS2(data) {
        return new Promise((resolve, reject) => {
            api.sendStatConsultationDHIS2(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}